import { ConfigItem } from 'Core/interfaces/filters'

export enum EPAFCSearchFields {
	searchByCode = 'searchByCode',
	searchByName = 'searchByName'
}

export declare namespace EPAFormCode {
	interface Basic extends CodeEntity {}

	namespace Form {
		interface Generic extends NameCode {}
	}

	namespace Search {
		interface Result {
			[EPAFCSearchFields.searchByCode]: string[]
			[EPAFCSearchFields.searchByName]: string[]
		}

		interface Config {
			[EPAFCSearchFields.searchByCode]: ConfigItem<EPAFCSearchFields>
			[EPAFCSearchFields.searchByName]: ConfigItem<EPAFCSearchFields>
		}
	}
}
